import { View, StyleSheet, Image, Platform } from 'react-native';
import React from 'react';
import { TRANSACTION_SCREEN } from './constant';
import Typography from '../../typography/Typography';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, TextAlignTokens } from '@voltmoney/schema';
const TransactionScreen = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(View, { style: styles.container },
            React.createElement(Image, { source: { uri: TRANSACTION_SCREEN }, style: styles.imageContainer, resizeMode: 'contain' })),
        React.createElement(View, { style: styles.textContainer },
            React.createElement(Typography, { label: "Your transactions will show up here after you start your credit line", fontSize: FontSizeTokens.MD, fontWeight: '500', fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Smoke, lineHeight: 20, textAlign: TextAlignTokens.center }))));
};
export default TransactionScreen;
const styles = StyleSheet.create({
    container: {
        marginHorizontal: 24,
        marginTop: 132,
        alignItems: 'center',
    },
    imageContainer: {
        height: Platform.OS !== 'web' ? 305 : 200,
        width: Platform.OS !== 'web' ? '100%' : 200,
    },
    textContainer: {
        marginLeft: 50,
        marginRight: 51,
        marginTop: 2,
    }
});
